import { Icon } from '@iconify/react';
import profileSetting from '@iconify/icons-mdi/account-settings-outline';
import dashboardIcon from '@iconify/icons-ic/outline-space-dashboard';
import classesIcon from '@iconify/icons-ic/round-cast-for-education';
import Iconify from '../../fl-components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const studentSidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(dashboardIcon)
  },
  {
    title: 'classes',
    path: '/dashboard/classes',
    icon: getIcon(classesIcon)
  },
  {
    title: 'discover',
    path: '/dashboard/discover',
    icon: <Iconify icon="healthicons:i-training-class" width={22} height={22} />
  },
  {
    title: 'offers',
    path: '/dashboard/offers',
    icon: <Iconify icon="bxs:offer" width={22} height={22} />
  },
  {
    title: 'account',
    path: '/dashboard/account',
    icon: getIcon(profileSetting)
  }
];

export default studentSidebarConfig;
